import { colors } from '../../colors';
var button = {
  //Hero button
  isHeroGradient: true,
  linkColorHero: colors.white,
  linkColorHeroHover: colors.white,
  backgroundColorHero: colors.dirtyBlue,
  backgroundColorHoverHero: colors.mutedBlue,
  borderRadiusHero: '0',
  linkLineHeightHero: '30px',
  heroButtonPadding: '20px 35px',
  //primary button
  isPrimaryGradient: true,
  linkColorPrimary: colors.white,
  linkColorPrimaryHover: colors.white,
  backgroundColorPrimary: colors.dirtyBlue,
  backgroundColorHoverPrimary: colors.mutedBlue,
  borderRadiusPrimary: '0',
  //secondary button
  isSecondaryGradient: true,
  linkColorSecondary: colors.white,
  linkColorSecondaryHover: colors.white,
  backgroundColorSecondary: colors.dirtyBlue,
  backgroundColorHoverSecondary: colors.mutedBlue,
  borderRadiusSecondary: '0',
  borderWidthSecondary: '0',
  borderColorSecondary: 'transparent',
  borderColorSecondaryHover: 'transparent'
};
export default button;